// import NameAvatarComponent from "../../../tenants/NameAvatarComponent";
import useInfiniteScroll from "react-infinite-scroll-hook";
import NameAvatarComponent from "../../../../newComponents/NameAvatar/NameAvatar";
import EmptyState from "../../../../newComponents/emptystate";
import AddButtonWithArrow from "../../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import SimpleSpinner from "../../../loader";
import { Colors } from "../../../GlobalCss/Colors";
import { TextCss } from "../../../GlobalCss/TextCss";

const Inbox = ({
  setEmailId,
  emailId,
  emaillist,
  threadlist,
  setcompose,
  listLoading = false,
  hasMoreThreads = false,
  onLoadMore,
}) => {
  const loadMore = () => {
    if (onLoadMore && !listLoading && hasMoreThreads) onLoadMore();
  };

  const [sentryRef] = useInfiniteScroll({
    loading: listLoading,
    hasNextPage: hasMoreThreads,
    onLoadMore: loadMore,
    disabled: !hasMoreThreads || listLoading,
    rootMargin: "0px 0px 100px 0px",
  });
  const categorizeEmails = (emailDate) => {
    const today = new Date().toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();
    if (emailDate === today) {
      return "Today";
    } else if (emailDate === yesterday) {
      return "Yesterday";
    } else {
      return "Older";
    }
  };


  const hasTodayEmails = threadlist.some(
    (email) => categorizeEmails(new Date(email?.date).toDateString()) === "Today"
  );
  const hasYesterdayEmails = threadlist.some(
    (email) => categorizeEmails(new Date(email?.date).toDateString()) === "Yesterday"
  );

  const data = [];

  if (hasTodayEmails) {
    data.push({
      id: "0",
      name: "Today",

    });
  }
  if (hasYesterdayEmails) {
    data.push({
      id: "1",
      name: "Yesterday",

    });
  }
  data.push({
    id: "2",
    name: "Older",
  });




  return (
    <>
      {listLoading && threadlist?.length === 0 ? (
        // Initial load (nothing fetched yet): a single centered spinner, not the "Older" header
        // plus an empty list with the infinite-scroll sentry's spinner stuck at the top of a
        // mostly-empty pane -- data still unconditionally includes an "Older" group even with zero
        // threads, which is what pushed the old loading-trigger spinner up under that header.
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
          <SimpleSpinner myClassName="Icon50" />
        </div>
      ) : threadlist?.length === 0 && !listLoading ? (
        <EmptyState
          heading="No Email Yet"
          bodytext="Please click the button below to compose an email."
          actionNode={
            <AddButtonWithArrow
              buttonname="Compose Email"
              onClick={() => {
                setEmailId(null)
                setcompose(true)
              }}
            />
          }
          isBorder={false}
        />
      ) : (
        <div className="inbox-email-list">
          {data?.map((item) => (
            <div className="AccordianItem" key={item.id}>
              <div className="Accordianheader">
                <p className="sub_text fw-700 grey_subtext1">{item.name}</p>
              </div>
              <div className="emailItemContaner">
                {
                  threadlist?.filter((email) => categorizeEmails(new Date(email?.date).toDateString()) === item.name)?.map((email, i, emailsArray) => {

                    const name = email?.fromName?.split(" ");
                    const isLastItem = i === emailsArray.length - 1;
                    const isEven = i % 2 === 0;

                    return (<div
                      key={email?.id ?? i}
                      style={{
                        background:
                          email?.id === emailId
                            ? "var(--Selected-Bg)"
                            : "",

                      }}
                      className={`emailItem ${isEven ? "" : "border-start-0"} `}
                      onClick={() => setEmailId(email?.id)}
                    >
                      <div className="userIcon">
                         <NameAvatarComponent
                                                  firstName={name?.length > 0 && name[0]}
                                                  lastName={name?.length > 1 ? name[1] : ""}
                                                  heightWidth={40}
                                                  shape="square"
                                                  className={TextCss.heading_700_16}
                                                  color={Colors.blue.regular}
                                                  backgroundColor={Colors.blue.lighter}
                                                />
                        {/* <NameAvatarComponent firstName={name?.length > 0 && name[0]}
                          lastName={name?.length > 1 ? name[1] : ""} heightWidth={40} /> */}
                      </div>
                      <div className="emailDetails">
                        <div className="email_details_header d-flex flex-row justify-content-between align-items-center w-100">
                          <p className="normal_text fw-600 text-start black ">{email?.fromName}</p>
                          <p className="sub_text grey_subtext1">{email?.displayDate}</p>
                        </div>
                        <p className="wrapemailSubject sub_text grey_subtext1">{email?.subject}</p>
                      </div>
                    </div>
                    )
                  })}
              </div>
            </div>
          ))}
          {(listLoading || hasMoreThreads) && (
            <div ref={sentryRef} className="loading-trigger">
              {listLoading && (
                <SimpleSpinner myClassName={threadlist?.length === 0 ? "Icon50" : "Icon40"} />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};


export default Inbox;

